
import { Screen } from "@/models/screen";
import { Ad } from "@/models/ad";
import { Sale } from "@/models/sale";

export const getScreenById = (screens: Screen[], id: string) =>
  screens.find(screen => screen.id === id);

export const getAdById = (ads: Ad[], id: string) =>
  ads.find(ad => ad.id === id);

export const getAdsByScreenId = (ads: Ad[], screenId: string) =>
  ads.filter(ad => ad.screens.some(screen => screen.screenId === screenId));

export const getSalesBySellerGrouped = (sales: Sale[]): { [sellerId: string]: Sale[] } => {
  // If no sales, return an empty object instead of an empty array
  if (!Array.isArray(sales) || sales.length === 0) {
    return {};
  }

  // Group sales by seller ID instead of seller name
  const groupedSales: { [sellerId: string]: Sale[] } = {};
  
  sales.forEach(sale => {
    const sellerId = sale.sellerId || 'unknown';
    if (!groupedSales[sellerId]) {
      groupedSales[sellerId] = [];
    }
    groupedSales[sellerId].push(sale);
  });
  
  return groupedSales;
};
